import type { BaseBodyResponse } from "./interfaces";
import { API_BASE_URL } from "../env";

const requestApi = async <T, B = unknown>(
    path: string,
    method: "POST" | "GET" = "GET",
    payload?: B
): Promise<BaseBodyResponse<T>> => {
    const url = `${API_BASE_URL}${path}`;
    const body = payload ? JSON.stringify(payload) : undefined;
    const response = await fetch(url, {
        method,
        body,
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });

    // e.g. POST /auth/logout returns 204 with no body.
    if (response.status === 204) {
        return { ok: true, data: undefined as T };
    }

    const json = await response.json().catch(() => null);

    if (!response.ok) {
        return {
            ok: false,
            error: json?.error || response.statusText,
        };
    }

    return { ok: true, data: json as T };
};

export default requestApi;
